import React, { useEffect, useState } from 'react';
import SEO from './SEO';

function ZoneIntervention({ departmentName, cities, seoTitle, seoDescription, seoPath }) {
    const [isVisible, setIsVisible] = useState(false);
    const [selectedCity, setSelectedCity] = useState(null);

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const getDepartmentInfo = (deptName) => {
        const deptMap = {
            'Paris (75)': { code: '75', color: '#C0A26B', description: 'Tous les arrondissements parisiens' },
            'Seine-Saint-Denis (93)': { code: '93', color: '#d4b875', description: 'Service complet dans le 93' },
            'Val-de-Marne (94)': { code: '94', color: '#e6c889', description: 'Expertise dans le Val-de-Marne' },
            'Seine-et-Marne (77)': { code: '77', color: '#f0d49d', description: 'Intervention en Seine-et-Marne' },
            'Essonne (91)': { code: '91', color: '#a67c52', description: 'Service professionnel en Essonne' },
            'Yvelines (78)': { code: '78', color: '#b8956b', description: 'Expertise dans les Yvelines' }
        };
        return deptMap[departmentName] || { code: '?', color: '#C0A26B', description: 'Zone d\'intervention' };
    };

    const deptInfo = getDepartmentInfo(departmentName);

    return (
        <section className="zone-section">
            <SEO
                title={seoTitle || `Antiquaire ${departmentName}`}
                description={seoDescription || `Antiquaire expert en ${departmentName}. Estimation gratuite a domicile dans ${cities.length} communes. Deplacement gratuit.`}
                path={seoPath}
            />
            <div className="section-container">
                <header className="zone-header">
                    <div className={`header-content ${isVisible ? 'animate-header' : ''}`}>
                        <div className="department-badge" style={{ '--dept-color': deptInfo.color }}>
                            {deptInfo.code}
                        </div>
                        <h1 className="zone-title">{departmentName}</h1>
                        <p className="zone-subtitle">{deptInfo.description}</p>
                    </div>
                </header>

                <main className="zone-content">
                    <div className="content-layout">
                        <div className="cities-section">
                            <div className="section-header">
                                <h2>Villes desservies</h2>
                                <p>Nous intervenons dans {cities.length} communes</p>
                            </div>
                            
                            <div className="cities-grid">
                                {cities.map((city, index) => (
                                    <div
                                        key={index}
                                        className={`city-card ${isVisible ? 'animate-city' : ''}`}
                                        style={{ '--delay': `${index * 0.05}s` }}
                                        onClick={() => setSelectedCity(selectedCity === city ? null : city)}
                                    >
                                        <div className="city-content">
                                            <h3 className="city-name">{city}</h3>
                                            <div className="city-indicator"></div>
                                        </div>
                                        <div className="city-glow"></div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="info-section">
                            <div className="info-card">
                                <h3>Service d'Excellence</h3>
                                <div className="service-features">
                                    <div className="feature-item">
                                        <span className="feature-icon">🏠</span>
                                        <span>Déplacement gratuit</span>
                                    </div>
                                    <div className="feature-item">
                                        <span className="feature-icon">⚡</span>
                                        <span>Expertise rapide</span>
                                    </div>
                                    <div className="feature-item">
                                        <span className="feature-icon">💰</span>
                                        <span>Paiement immédiat</span>
                                    </div>
                                    <div className="feature-item">
                                        <span className="feature-icon">🔍</span>
                                        <span>Évaluation précise</span>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-card">
                                <h3>Contactez-nous</h3>
                                <p>Intervention sous 48h dans tout le département</p>
                                <a href="tel:0658084516" className="contact-button">
                                    06 58 08 45 16
                                </a>
                            </div>
                        </div>
                    </div>
                </main>
            </div>

            <style jsx>{`
                .zone-section {
                    min-height: 100vh;
                    background: linear-gradient(135deg, #f2f5f7 0%, #e8ecef 100%);
                    padding: 100px 24px 80px;
                    position: relative;
                }

                .section-container {
                    max-width: 1400px;
                    margin: 0 auto;
                }

                .zone-header {
                    text-align: center;
                    margin-bottom: 80px;
                    padding: 60px 0;
                    background: linear-gradient(135deg, #fff 0%, #f8fafb 100%);
                    border-radius: 24px;
                    position: relative;
                    overflow: hidden;
                }

                .zone-header::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    background: radial-gradient(circle at 50% 100%, rgba(192, 162, 107, 0.1) 0%, transparent 70%);
                }

                .header-content {
                    position: relative;
                    z-index: 2;
                    opacity: 0;
                    transform: translateY(30px);
                    transition: all 0.8s ease;
                }

                .animate-header {
                    opacity: 1 !important;
                    transform: translateY(0) !important;
                }

                .department-badge {
                    display: inline-block;
                    background: var(--dept-color);
                    color: #20453d;
                    font-size: 2rem;
                    font-weight: 700;
                    padding: 16px 24px;
                    border-radius: 16px;
                    margin-bottom: 24px;
                    min-width: 80px;
                    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
                }

                .zone-title {
                    font-size: 3rem;
                    font-weight: 700;
                    color: #1f2b2a;
                    margin: 0 0 16px;
                    letter-spacing: -0.02em;
                }

                .zone-subtitle {
                    font-size: 1.3rem;
                    color: #44504f;
                    margin: 0;
                    font-style: italic;
                }

                .content-layout {
                    display: grid;
                    grid-template-columns: 2fr 1fr;
                    gap: 60px;
                    align-items: start;
                }

                .cities-section {
                    background: #fff;
                    border-radius: 24px;
                    padding: 48px;
                    box-shadow: 0 8px 32px rgba(0,0,0,0.08);
                }

                .section-header {
                    text-align: center;
                    margin-bottom: 40px;
                }

                .section-header h2 {
                    font-size: 2.2rem;
                    color: #1f2b2a;
                    margin: 0 0 8px;
                    font-weight: 600;
                }

                .section-header p {
                    color: #44504f;
                    margin: 0;
                    font-size: 1.1rem;
                }

                .cities-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
                    gap: 16px;
                }

                .city-card {
                    position: relative;
                    background: linear-gradient(135deg, #f8fafb 0%, #f2f5f7 100%);
                    border-radius: 12px;
                    padding: 20px 16px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    border: 2px solid transparent;
                    opacity: 0;
                    transform: translateY(20px);
                    overflow: hidden;
                }

                .animate-city {
                    opacity: 1 !important;
                    transform: translateY(0) !important;
                    transition-delay: var(--delay);
                }

                .city-card:hover {
                    transform: translateY(-4px);
                    border-color: var(--dept-color, #C0A26B);
                    box-shadow: 0 8px 24px rgba(0,0,0,0.12);
                }

                .city-glow {
                    position: absolute;
                    top: -50%;
                    left: -50%;
                    width: 200%;
                    height: 200%;
                    background: radial-gradient(circle, var(--dept-color, #C0A26B) 0%, transparent 70%);
                    opacity: 0;
                    transition: opacity 0.3s ease;
                    z-index: 0;
                }

                .city-card:hover .city-glow {
                    opacity: 0.05;
                }

                .city-content {
                    position: relative;
                    z-index: 2;
                    text-align: center;
                }

                .city-name {
                    font-size: 1rem;
                    font-weight: 500;
                    color: #1f2b2a;
                    margin: 0 0 8px;
                    line-height: 1.3;
                }

                .city-indicator {
                    width: 20px;
                    height: 2px;
                    background: var(--dept-color, #C0A26B);
                    border-radius: 1px;
                    margin: 0 auto;
                    transition: width 0.3s ease;
                }

                .city-card:hover .city-indicator {
                    width: 40px;
                }

                .info-section {
                    display: flex;
                    flex-direction: column;
                    gap: 24px;
                    position: sticky;
                    top: 120px;
                }

                .info-card,
                .contact-card {
                    background: #fff;
                    border-radius: 20px;
                    padding: 32px 24px;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.08);
                    transition: all 0.3s ease;
                }

                .info-card:hover,
                .contact-card:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 8px 32px rgba(0,0,0,0.12);
                }

                .info-card h3,
                .contact-card h3 {
                    font-size: 1.4rem;
                    color: #1f2b2a;
                    margin: 0 0 20px;
                    text-align: center;
                    font-weight: 600;
                }

                .service-features {
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                }

                .feature-item {
                    display: flex;
                    align-items: center;
                    gap: 12px;
                    padding: 12px 16px;
                    background: #f8fafb;
                    border-radius: 10px;
                    transition: all 0.3s ease;
                }

                .feature-item:hover {
                    background: #f2f5f7;
                    transform: translateX(4px);
                }

                .feature-icon {
                    font-size: 1.2rem;
                    width: 24px;
                    text-align: center;
                }

                .feature-item span:last-child {
                    color: #44504f;
                    font-weight: 500;
                }

                .contact-card {
                    background: linear-gradient(135deg, #20453d 0%, #1a3a33 100%);
                    color: #fff;
                    text-align: center;
                }

                .contact-card h3 {
                    color: #C0A26B;
                }

                .contact-card p {
                    color: rgba(255,255,255,0.9);
                    margin: 0 0 24px;
                    line-height: 1.6;
                }

                .contact-button {
                    display: inline-block;
                    background: linear-gradient(135deg, #C0A26B 0%, #d4b875 100%);
                    color: #20453d;
                    padding: 14px 28px;
                    text-decoration: none;
                    border-radius: 25px;
                    font-weight: 700;
                    font-size: 1.1rem;
                    transition: all 0.3s ease;
                    box-shadow: 0 4px 16px rgba(192, 162, 107, 0.3);
                }

                .contact-button:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 6px 20px rgba(192, 162, 107, 0.4);
                }

                @media (max-width: 1024px) {
                    .content-layout {
                        grid-template-columns: 1fr;
                        gap: 40px;
                    }

                    .info-section {
                        position: static;
                        flex-direction: row;
                        gap: 20px;
                    }

                    .info-card,
                    .contact-card {
                        flex: 1;
                    }
                }

                @media (max-width: 768px) {
                    .zone-section {
                        padding: 80px 20px 60px;
                    }

                    .zone-header {
                        margin-bottom: 60px;
                        padding: 40px 24px;
                    }

                    .zone-title {
                        font-size: 2.5rem;
                    }

                    .zone-subtitle {
                        font-size: 1.1rem;
                    }

                    .cities-section {
                        padding: 32px 24px;
                    }

                    .cities-grid {
                        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
                        gap: 12px;
                    }

                    .city-card {
                        padding: 16px 12px;
                    }

                    .info-section {
                        flex-direction: column;
                        gap: 16px;
                    }

                    .info-card,
                    .contact-card {
                        padding: 24px 20px;
                    }
                }

                @media (max-width: 480px) {
                    .zone-section {
                        padding: 100px 16px 48px;
                    }

                    .zone-header {
                        padding: 32px 20px;
                    }

                    .zone-title {
                        font-size: 2rem;
                        line-height: 1.2;
                    }

                    .department-badge {
                        font-size: 1.6rem;
                        padding: 12px 20px;
                    }

                    .cities-section {
                        padding: 24px 16px;
                    }

                    .cities-grid {
                        grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
                        gap: 8px;
                    }

                    .city-card {
                        padding: 12px 8px;
                    }

                    .city-name {
                        font-size: 0.9rem;
                    }
                }
            `}</style>
        </section>
    );
}

export default ZoneIntervention;
